var S = require('./settings.js'),
    moment = require('moment'),
    Backbone = require('backbone'),
    $ = require('jquery'),
    fvChannel =  require('glRadio').channel('FV');

require('jqAsyncQueue');

/*
 * Model is really the model of the client version.json file (in the Backbone sense, with attributes) --
 * It started this way though now combines a call to versionInfo to get DV Services and CRE version. 
 * ( Now there's a clearer ways to handle but this works ).
 * Provides the data necessary to populate the 'about' dialog -- so now really a composite 'about model'.
 * Client Version - Retrieved From Flat File
 * Viewer Services and CRE Versions - retrieved from versionInfo webservice
 */

var VersionModel = Backbone.Model.extend({

    /*
    * DATE_FORMAT_STR: that defined in pom.xml <maven.build.timestamp.format> for this project.
    * Note that it's different than the Maven default; this was done so ":"'s don't appear in the file name generated for viewer.js in the webjar
    * ( See DOCVIEW-212).
    * Note: we need to define it on parse since it's not a valid ISO 8601 format ( we removed the ":'"s ).
    * eg: 2019-08-26T17-26-32Z
    * Update: DVBC-1622 -- the Maven format string was invalid and produced the wrong date -- changed to the current format:
    * */

    DATE_FORMAT_STR: 'YYYY-MM-DDTHH-mm-ssZ',

    initialize: function() {
        this.wasFetched = false;
        this.servicesModel = null;
        this.creServiceModel = null;
    },

    // Note: defaults here only refer to the client file and only include the attributes used
    defaults: {
        'version': '',  // string - number (eg x.x.x)
        'build': ''     // datetimestamp
    },
    url: function() {
        return fvChannel.request('settings').pathToVersionFile(); 
    },
    // Combo the fetch of version.json file and the webservice call into one action.
    // Consolidate any potential errors into one message for convenience of caller ( requires both to complete ).
    fetch: function(cxt) {
        
        cxt = cxt ? cxt : this;
        var self = this;
        
        return $.Deferred(function($dfd) {
            
            var feithLibs = new FeithLibs(),  
                q = $.AsyncQueue(),
                clientErr,
                servicesErr, // error message trying to access the versionInfo endpoint: Doc Viewer Services / CRE
                rejectDfd = function() { 
                    var errMsg = '';
                    if (clientErr && !servicesErr) {
                        errMsg = 'Unable to retrieve client version data. '  + clientErr;
                    } else if (!clientErr && servicesErr) {
                        errMsg = 'Unable to retrieve server version data. '  + servicesErr;
                    } else if (clientErr && servicesErr) {
                        errMsg = 'Unable to retrieve client and server version data.\nClient: ' + clientErr + '\nServer: ' + servicesErr;
                    }
                    $dfd.rejectWith(cxt, [errMsg]);
                };

            q.add({
                action: 'Client',
                method: _.bind( Backbone.Model.prototype.fetch, self ), errorCB: function () { 
                    clientErr = this.error; 
                } 
            })
            .add({ // This will get both Doc Viewer Web Services & CRE Version
                action: 'Services',
                method: _.bind( feithLibs.fetch ,feithLibs ), errorCB: function() { 
                    servicesErr = this.error; 
                }
            });

            q.run().done(function() {

                if (!clientErr && !servicesErr) {
                    
                    self.wasFetched = true;
                    self.servicesModel = feithLibs.getDocViewerService();
                    self.creServiceModel = feithLibs.getCREService();

                    $dfd.resolveWith(cxt);

                } else {
                    rejectDfd();
                }

            }).fail(rejectDfd); //(don't think need fail....)

        }).promise();

    },
    // Return the 'build date'
    getFormattedDate: function() {

        var build = this.get('build');
        if (build === '' || build === null ) {
            return 'Unable to locate version.json';
        } else {
            return this.getBuild();
        }

    },
    getCopyRightDate: function() {
        return moment( this.get('build'), this.DATE_FORMAT_STR).year();
    },
    getVersion: function() {
        return this.get('version');
    },
    getBuild: function() {

        return moment
            .utc( this.get('build') , this.DATE_FORMAT_STR )
            .local()
            .format(S.DT_TIME_FMT_AMPM_SPACE_BF_CAPS_STR);

    }
});


var FeithLibModel = VersionModel.extend({

    /*
     * DATE_FORMAT_STR: The default for Maven -- 2017-02-03T22:59:43Z' -- for example.
     * It's a valid ISO 8601 format so we don't technically need to define to read the value,
     * but providing nonetheless for clarity.
     * Update DVBC-1619: "yyyy-MM-dd'T'HH:mm:ss'Z'" was incorrect, changed to below:
     * */

    DATE_FORMAT_STR: "YYYY-MM-DDTHH:mm:ssZ",

    defaults: {
        title: '',
        version: '',
        build: ''
    }
});


/*
* Note: this endpoint was moved from FDD rest library v1 into Doc Viewer.
* With the logic to get the version can be greatly simplified utilizing the endpoint
* that exists in the Doc Viewer application.
* */
var FeithLibs = Backbone.Collection.extend({
    DOC_VIEWER_SERVICES_TITLE: 'document-viewer-rest-cxf',
    CRE_SERVICE_TITLE: 'central-rendering-engine-service', 
    model: FeithLibModel,
    url: function() {
        return fvChannel.request('apiUrl').feithLibraryVersionInfo;
    },
    getDocViewerService: function() {
        return this.findWhere({title: this.DOC_VIEWER_SERVICES_TITLE});
    },
    getCREService: function() {
        return this.findWhere({title: this.CRE_SERVICE_TITLE});
    }

});



module.exports = VersionModel;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/version.js
 ** module id = 763
 ** module chunks = 0
 **/